import { render, staticRenderFns } from "./whoisSearch.vue?vue&type=template&id=a4933856&scoped=true&"
import script from "./whoisSearch.vue?vue&type=script&lang=js&"
export * from "./whoisSearch.vue?vue&type=script&lang=js&"
import style0 from "./whoisSearch.vue?vue&type=style&index=0&id=a4933856&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a4933856",
  null
  
)

export default component.exports